module.exports = __webpack_public_path__ + "img/ajax.f55ca23c.png";